module.exports = __webpack_public_path__ + "img/sixpackcarrier78.d1a29d9b.jpg";